// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3HjwD","col":"styles_col__3Qjzz"};